import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Button, Tooltip, Badge, Input, Label } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService";

import DataTableBloc from "../Blocs/DataTableBloc";
import IndexBloc from "../Blocs/IndexBloc";
import apiResponse from "../../../../../services/apiResponse";
import moment from "moment";
import { Link } from "react-router-dom";

class TableActiveComponent extends Component {
  dataTableBloc = new DataTableBloc();
  indexBloc = new IndexBloc();

  historyTable = "PegawaiPromotionsTableActive";
  defaultOrder = "promotion_employee_name";
  defaultSize = 10;
  defaultSort = "asc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };
  modal_confirm_status = 0;
  modal_confirm_message = "";
  modal_confirm_sucess_message = "data berhasil diproses";
  modal_confirm_error_message = "data gagal diproses";

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,

              order: this.defaultSort,
            },
          },
      dataSelected: [],
      checkAll: false,
    };
  }
  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      uuid: this.props.uuid,
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
      is_process: 0,
    };
    await this.dataTableBloc.fetchRowTable(query, this.source.token);
  };

  handleChecked = (e, uuid) => {
    var checked = e.target.checked;
    if (checked) {
      this.setState({
        dataSelected: [...this.state.dataSelected, uuid],
      });
    } else {
      var filteredAry = this.state.dataSelected.filter((e) => e !== uuid);
      this.setState({
        dataSelected: filteredAry,
      });
    }
    console.log(uuid, checked);
  };

  handleCheckAll = (e) => {
    let checked = e.target.checked;
    let uuidSelected = [];
    for (let i = 0; i < this.state.rows.length; i++) {
      let thisId = this.state.rows[i].promotion_id;
      let thisUuid = this.state.rows[i].promotion_uuid;
      this.setState({
        [`check${thisId}`]: !this.state.checkAll,
      });
      if (checked == true) {
        uuidSelected[i] = thisUuid;
      }
    }

    this.setState({
      checkAll: !this.state.checkAll,
      dataSelected: uuidSelected,
    });
  };

  handleButtonProcess = () => {
    console.log(this.state.dataSelected);
    this.modal_confirm_message =
      "Apakah anda yakin akan menambahkan pegawai terpilih?";
    this.modal_confirm_status = 1;
    this.setState({
      confirm: true,
    });
  };

  handleButtonGenerate = () => {
    this.modal_confirm_message =
      "Apakah anda yakin generate ulang Rekomendasi?";
    this.modal_confirm_status = 2;
    this.setState({
      confirm: true,
    });
  };
  resetTable = () => {
    this.setState({
      dataSelected: [],
    });
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        let data_status = parseInt(this.modal_confirm_status);
        if (data_status === 1) {
          let formData = {
            uuids: this.state.dataSelected,
          };
          this.indexBloc.fetchProcess(formData);
        } else if (data_status === 2) {
          let formData = {
            uuid: this.props.uuid,
          };
          this.indexBloc.fetchGenerate(formData);
        } else {
          this.activeData();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };
  activeData = async () => {
    await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    this.setTokenAPI();

    this.dataTableBloc.rowtableChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;

          // set state for every checkbox
          for (let i = 0; i < response.result.length; i++) {
            let thisId = response.result[i].promotion_id;
            this.setState({
              [`check${thisId}`]: false,
            });
          }
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.dataTableBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              this.props.handleInactiveSuccess();
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.processChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState(
              {
                loading: false,
                success: true,
              },
              function () {
                this.setTokenAPI();
                this.resetTable();
                this.props.handleProcessSuccess();
              }
            );
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
    this.indexBloc.generateChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            this.setState(
              {
                loading: false,
                success: true,
              },
              function () {
                this.setTokenAPI();
                this.resetTable();
                //this.props.handleInactiveSuccess();
              }
            );
          } else {
            this.setState({
              loading: false,
              message: result.data.message,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.dataTableBloc.rowtableChannel.unsubscribe();
  }

  columns = [
    {
      key: "promotion_id",
      text: "Pilih",
      className: "promotion_id",
      sortable: false,
      header: () => {
        return (
          <div className="form-check text-center font-size-16">
            <Input
              className="form-check-input"
              type="checkbox"
              name="checkAll"
              value=""
              checked={this.state.checkAll}
              onChange={(event) => {
                this.handleCheckAll(event);
              }}
            />
          </div>
        );
      },
      cell: (record) => {
        const thisId = record.promotion_id;
        return (
          <div className="form-check text-center font-size-16">
            <Input
              type="checkbox"
              className="form-check-input"
              id={"checkbox" + thisId}
              onChange={(event) => {
                this.handleChecked(event, record.promotion_uuid);
                this.setState({
                  [`check${thisId}`]: !this.state[`check${thisId}`],
                });
              }}
              checked={this.state[`check${thisId}`]}
            />
          </div>
        );
      },
    },
    {
      key: "employee_nip",
      text: "Pegawai",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                "<b>" +
                record.employee_nip +
                "</b><br>" +
                record.employee_full_name,
            }}
          />
        );
      },
    },
    {
      key: "promotion_work_unit_name",
      text: "Unit Kerja",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html:
                record.promotion_work_unit_name != null
                  ? record.promotion_work_unit_name.replace(/»/g, "<br>")
                  : "",
            }}
          />
        );
      },
    },
    {
      key: "promotion_rank_name_old",
      text: "Pangkat",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: record.promotion_rank_name_old,
            }}
          />
        );
      },
    },
    {
      key: "promotion_rank_group_room_old",
      text: "Golongan",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: record.promotion_rank_group_room_old,
            }}
          />
        );
      },
    },
    {
      key: "promotion_rank_tmt_old",
      text: "TMT Pangkat",
      className: "",
      sortable: true,
      cell: (record) => {
        let res = "-";
        if (
          record.promotion_rank_tmt_old != null &&
          record.promotion_rank_tmt_old != ""
        ) {
          res = moment(record.promotion_rank_tmt_old).format("DD-MM-YYYY");
        }
        return res;
      },
    },
    {
      key: "rank_group_room",
      text: "Masa Kerja",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <>
            <b>{record.promotion_year_period_old}</b> Thn
            <div>
              <b>{record.promotion_month_period_old}</b> Bln
            </div>
          </>
        );
      },
    },
    {
      key: "rank_group_room",
      text: "Masa Kerja Usulan",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <>
            <b>{record.promotion_year_period}</b> Thn
            <div>
              <b>{record.promotion_month_period}</b> Bln
            </div>
          </>
        );
      },
    },

    {
      key: "rank_type_name",
      text: "Jenis Kenaikan Pangkat",
      className: "",
      sortable: true,
      cell: (record) => {
        return (
          <div dangerouslySetInnerHTML={{ __html: record.rank_type_name }} />
        );
      },
    },
    {
      key: "punishments",
      text: "Hukuman Disiplin",
      className: "punishments",
      sortable: true,
      cell: (record) => {
        let punishments = record.punishments;
        if (typeof record.punishments !== "undefined") {
          return punishments.map((item) => (
            <li key={item.punishment_id}> {item.punishment_long_name} </li>
          ));
        }
        return "-";
      },
    },
    {
      key: "promotion_status",
      text: "Status",
      sortable: false,
      cell: (record) => {
        let status = parseInt(record.promotion_status);
        if (status == -1) {
          status = (
            <label className="badge rounded-pill bg-soft-info font-size-12">
              Rekomendasi
            </label>
          );
        } else if (status == 0) {
          status = (
            <label className="badge rounded-pill bg-soft-success font-size-12">
              Menunggu Proses
            </label>
          );
        } else if (status == 1) {
          status = (
            <label className="badge rounded-pill bg-soft-success font-size-12">
              Disetujui
            </label>
          );
        } else if (status == 2) {
          status = (
            <label className="badge rounded-pill bg-soft-error font-size-12">
              Ditolak
            </label>
          );
        }
        return <span> {status} </span>;
      },
    },
    // {
    //   key: "action",
    //   text: "Action",
    //   className: "action",
    //   width: 120,
    //   sortable: false,
    //   align: "center",
    //   cell: (record) => {
    //     const thisId = record.promotion_id;
    //     return (
    //       <Fragment>
    //         {record.promotion_is_rekomendation == 1 &&
    //         record.promotion_status == -1 &&
    //         accessRole("update") ? (
    //           <span>
    //             <button
    //               className="btn btn-primary btn-sm"
    //               id={"update-" + thisId}
    //               onClick={() => {
    //                 this.setState({
    //                   updateUuid: record.employee_uuid,
    //                 });
    //               }}
    //               style={{
    //                 marginRight: "2px",
    //                 padding: "2px 5px",
    //               }}
    //             >
    //               <i className="uil-list-ul"></i>
    //             </button>
    //             <Tooltip
    //               style={{
    //                 marginBottom: 2,
    //               }}
    //               placement="top"
    //               isOpen={this.state["update" + thisId]}
    //               target={"update-" + thisId}
    //               toggle={() => {
    //                 this.setState({
    //                   ["update" + thisId]: !this.state["update" + thisId],
    //                 });
    //               }}
    //             >
    //               Masukan ke daftar
    //             </Tooltip>
    //           </span>
    //         ) : null}

    //         {record.promotion_status == 0 && accessRole("update") ? (
    //           <span>
    //             <Link to={`?verifikasi&uuid=` + this.props.uuid+`&pegawai_uuid=`+record.employee_uuid}>
    //               <button

    //                 className="btn btn-success btn-sm"
    //                 id={"verifikasi-" + thisId}

    //                 style={{
    //                   marginRight: "2px",
    //                   padding: "2px 5px",
    //                 }}
    //               >
    //                 <i className="uil-check"></i>
    //               </button>
    //               <Tooltip
    //                 style={{
    //                   marginBottom: 2,
    //                 }}
    //                 placement="top"
    //                 isOpen={this.state["verifikasi" + thisId]}
    //                 target={"verifikasi-" + thisId}
    //                 toggle={() => {
    //                   this.setState({
    //                     ["verifikasi" + thisId]:
    //                       !this.state["verifikasi" + thisId],
    //                   });
    //                 }}
    //               >
    //                 Verifikasi
    //               </Tooltip>
    //             </Link>
    //           </span>
    //         ) : null}

    //         {record.promotion_status == 1 && accessRole("update") ? (
    //           <span>
    //             <Link to={`?detail&uuid=` + this.props.uuid+`&pegawai_uuid=`+record.employee_uuid}>
    //               <button

    //                 className="btn btn-success btn-sm"
    //                 id={"detail-" + thisId}

    //                 style={{
    //                   marginRight: "2px",
    //                   padding: "2px 5px",
    //                 }}
    //               >
    //                 <i className="uil-file-search-alt"></i>
    //               </button>
    //               <Tooltip
    //                 style={{
    //                   marginBottom: 2,
    //                 }}
    //                 placement="top"
    //                 isOpen={this.state["detail" + thisId]}
    //                 target={"detail-" + thisId}
    //                 toggle={() => {
    //                   this.setState({
    //                     ["detail" + thisId]:
    //                       !this.state["detail" + thisId],
    //                   });
    //                 }}
    //               >
    //                 Detail
    //               </Tooltip>
    //             </Link>
    //           </span>
    //         ) : null}
    //       </Fragment>
    //     );
    //   },
    // },
  ];

  render() {
    return (
      <>
        <b>
          Data Terpilih :{" "}
          <Badge className="rounded-pill bg-success font-size-12">
            {" "}
            {this.state.dataSelected.length}{" "}
          </Badge>{" "}
          dari total{" "}
          <Badge className="rounded-pill bg-warning font-size-12">
            {" "}
            {this.state.totalRow}{" "}
          </Badge>
        </b>
        &nbsp;&nbsp;&nbsp;&nbsp;
        {accessRole("create") ? (
          <Button
            color="primary"
            onClick={() => {
              this.handleButtonProcess();
            }}
            disabled={this.state.dataSelected.length > 0 ? false : true}
          >
            Masukan Pegawai Terpilih
          </Button>
        ) : null}
        &nbsp;&nbsp;&nbsp;&nbsp;
        {accessRole("create") && this.props.datasource == 0 ? (
          <Button
            color="success"
            onClick={() => {
              this.handleButtonGenerate();
            }}
          >
            Generate Ulang Rekomendasi
          </Button>
        ) : null}
        <hr />
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo={this.modal_confirm_message}
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo={this.modal_confirm_sucess_message}
          failedTitle="Gagal!"
          failedInfo={this.modal_confirm_error_message}
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={`/kepegawaian/kenaikan_pangkat.html?pegawai&verifikasi&uuid=${this.props.uuid}&period_promotion_uuid=${this.state.detailUuid}`}
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={`/kepegawaian/kenaikan_pangkat.html?addpegawai&uuid=${this.props.uuid}&pegawai_uuid=${this.state.updateUuid}`}
          />
        ) : null}
        {/* {console.log(this.state.VerifikasiUuid)} */}
      </>
    );
  }
}

export default TableActiveComponent;
